<template>
	<slot></slot>
</template>

<script setup lang="ts">
import {provide} from "vue";
import {rowObjectKey} from "@fd/containers/agenda/AgendaUtils.ts";

const props = defineProps<{
	itemKey: number | string;
}>();

provide(rowObjectKey, props.itemKey);
</script>
